import { z } from 'zod';
/**
 * `POST /api/hire-inquiries` — the "Hire a Property Manager" page's inquiry
 * form. Deliberately not CLAUDE.md's "Inquiry / tour request" funnel step
 * (no staff queue, no database row): the ask was a simple form that emails
 * the firm's configured contact inbox through the existing mail
 * infrastructure, nothing more.
 *
 * `website` is a honeypot — hidden from a real visitor via CSS, so a
 * non-empty value means a bot filled every field on the form. It's kept
 * optional and unbounded-looking here (validated, not rejected) so a filled
 * honeypot doesn't itself 400 and tip the sender off; the service layer
 * drops the submission silently when it's non-empty.
 */
export const hirePropertyManagerInquirySchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(200),
    email: z.string().trim().email('Enter a valid email address').max(320),
    phone: z.string().trim().max(40).optional(),
    message: z.string().trim().max(4000).optional(),
    website: z.string().max(200).optional(),
});
//# sourceMappingURL=hire-inquiry.js.map